<template>
	<svg
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M16 2.66669C13.3629 2.66669 10.785 3.44867 8.59239 4.91376C6.39974 6.37884 4.69077 8.46123 3.6816 10.8976C2.67243 13.3339 2.40839 16.0148 2.92286 18.6012C3.43733 21.1876 4.70721 23.5634 6.57191 25.4281C8.43661 27.2928 10.8124 28.5627 13.3988 29.0772C15.9852 29.5916 18.6661 29.3276 21.1024 28.3184C23.5388 27.3092 25.6212 25.6003 27.0863 23.4076C28.5513 21.215 29.3333 18.6371 29.3333 16C29.3333 14.2491 28.9885 12.5152 28.3184 10.8976C27.6483 9.2799 26.6662 7.81004 25.4281 6.57193C24.19 5.33382 22.7201 4.35169 21.1024 3.68163C19.4848 3.01156 17.751 2.66669 16 2.66669ZM16 26.6667C13.8903 26.6667 11.828 26.0411 10.0739 24.869C8.31979 23.697 6.95262 22.0311 6.14528 20.082C5.33795 18.1329 5.12671 15.9882 5.53829 13.9191C5.94986 11.8499 6.96576 9.94931 8.45752 8.45755C9.94928 6.96579 11.8499 5.94989 13.919 5.53831C15.9882 5.12674 18.1329 5.33797 20.082 6.14531C22.031 6.95264 23.6969 8.31981 24.869 10.0739C26.0411 11.8281 26.6667 13.8904 26.6667 16C26.6667 18.829 25.5429 21.5421 23.5425 23.5425C21.5421 25.5429 18.829 26.6667 16 26.6667Z"
			fill="#78D090"
		/>
		<path
			d="M19.5997 11.1867L14.5597 17.8534L12.3864 15.0401C12.1689 14.7607 11.8494 14.5792 11.4981 14.5354C11.1467 14.4917 10.7924 14.5893 10.5131 14.8067C10.2337 15.0242 10.0522 15.3438 10.0084 15.6951C9.96467 16.0464 10.0623 16.4007 10.2797 16.6801L13.5197 20.8267C13.6453 20.9856 13.8054 21.1139 13.9879 21.2016C14.1704 21.2894 14.3705 21.3345 14.5731 21.3334C14.7767 21.3329 14.9775 21.2858 15.1601 21.1957C15.3427 21.1055 15.5022 20.9748 15.6264 20.8134L21.7197 12.8134C21.9355 12.5305 22.0299 12.1735 21.9824 11.8209C21.9349 11.4684 21.7493 11.1491 21.4664 10.9334C21.1835 10.7177 20.8265 10.6232 20.4739 10.6707C20.1214 10.7182 19.8021 10.9038 19.5864 11.1867H19.5997Z"
			fill="#78D090"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconCheckmark',
}
</script>
